import React from 'react';

import PropTypes from 'prop-types';
import styled from 'styled-components';

import BuilderLocalizedRichText from '~/shared/components/BuilderLocalizedRichText';
import BuilderLocalizedText from '~/shared/components/BuilderLocalizedText';
import fontFamilies from '~/styles/themes/fontFamilies';

const HeadingContainer = styled.div`
  font-family: ${({ fontFamily }) => fontFamilies[fontFamily]};
  text-align: ${({ textAlign }) => textAlign};
  background-color: ${({ backgroundColor }) => backgroundColor};
  color: ${({ textColor }) => textColor};
`;

const Title = styled.div`
  font-size: 32px;
  font-weight: 700;
  margin-left: 5px;
  margin-right: 5px;
  line-height: 42px;
`;

const Subtitle = styled.div`
  font-size: 16px;
  font-weight: 400;
  margin-left: 5px;
  margin-right: 5px;
  line-height: 26px;
`;

const BuilderHeading = (props) => {
  const { fontFamily, textAlign, title, subtitle, backgroundColor, textColor } =
    props;

  return (
    <HeadingContainer
      fontFamily={fontFamily}
      textAlign={textAlign}
      backgroundColor={backgroundColor}
      textColor={textColor}
      data-builder-component-type="heading"
    >
      <Title>
        <BuilderLocalizedText text={title} />
      </Title>

      {subtitle && (
        <Subtitle>
          <BuilderLocalizedRichText text={subtitle} />
        </Subtitle>
      )}
    </HeadingContainer>
  );
};

BuilderHeading.propTypes = {
  backgroundColor: PropTypes.object,
  fontFamily: PropTypes.string,
  subtitle: PropTypes.object,
  textAlign: PropTypes.object,
  textColor: PropTypes.object,
  title: PropTypes.object,
};

export default BuilderHeading;
